import { QueryFactory } from "../../../../Common";
export const QReport = QueryFactory("Report");
//# sourceMappingURL=QReport.js.map